/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { PlainCard } from 'components/cards';
import { Icon, ShortText, Button } from 'components/common';

import * as styles from './CertificateSection.styles';

const CertificateSection = ({ data, setAddCertificateModal, setEditCertificateModal }) => (
  <PlainCard styles={styles.cardStyles}>
    <div css={styles.topContainerStyles}>
      <ShortText>certificates</ShortText>
      <Button styles={styles.buttonIconStyles} type="button" onClick={setAddCertificateModal}>
        <Icon name="plus" />
      </Button>
    </div>
    <div css={styles.horizontalLineStyles} />
    {
      data.track_records?.certificate.map((d) => (
        <div key={d.id} css={styles.certificateContainerStyles}>
          <div css={styles.oneCertificateContainerStyles}>
            <div css={styles.firstLineContainerStyles}>
              <ShortText styles={styles.projectTitleStyles}>
                {d.title}
              </ShortText>
              <Button styles={styles.buttonIconStyles} type="button" onClick={() => setEditCertificateModal(d)}>
                <Icon name="pen" />
              </Button>
            </div>
            <ShortText styles={styles.certificationTypeStyles}>
              {d.institution_name}
            </ShortText>
            <ShortText styles={styles.explanationTextStyles}>
              {d.description}
            </ShortText>
            <a href={d.link} target="_blank" rel="noreferrer" css={styles.linkStyles}>
              {d.link}
            </a>
          </div>
        </div>
      ))
    }
  </PlainCard>
);

CertificateSection.propTypes = {
  data: PropTypes.shape({
    track_records: PropTypes.shape({
      certificate: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  setAddCertificateModal: PropTypes.func.isRequired,
  setEditCertificateModal: PropTypes.func.isRequired,
};

export default CertificateSection;
